import React from 'react';
import { Target, Eye } from 'lucide-react';
import { fallbackContent } from '../hooks/useContent';

const WhoWeAre = ({ data = fallbackContent.whoweare }) => {
  const cards = [
    { icon: Target, ...data.mission },
    { icon: Eye, ...data.vision },
  ];
  return (
    <section id="about" className="py-20 lg:py-28 bg-[#12263f] text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="section-label text-[#c9a227] mb-4">Who We Are</p>
            <h2 className="font-display font-bold text-4xl lg:text-5xl leading-tight">{data.heading}</h2>
            <p className="mt-6 text-white/70 leading-relaxed">{data.paragraph}</p>
          </div>

          <div className="grid sm:grid-cols-2 gap-5">
            {cards.map((m, i) => {
              const Icon = m.icon;
              return (
                <div key={i} className="bg-white/5 border border-white/10 rounded-2xl p-7 hover:bg-white/10 transition-colors">
                  <div className="w-11 h-11 rounded-xl bg-[#c9a227]/15 flex items-center justify-center">
                    <Icon size={20} className="text-[#c9a227]" />
                  </div>
                  <h3 className="font-display font-bold text-xl mt-5">{m.title}</h3>
                  <p className="mt-3 text-sm text-white/60 leading-relaxed">{m.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
